import { COLOR_BLUE_BASE } from '@alltrails/denali/tokens';
import { currentMarkerId } from '../layers';
import { createCircleMarker } from './svgMarkerComponents';

const currentSvg = createCircleMarker({ imageName: currentMarkerId, innerDiameter: 16, innerFill: COLOR_BLUE_BASE });

export default currentSvg;
